import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";
import type { ReadonlyRefOrGetter } from "@vueuse/core";

export default function useParagraphOldVersionId(
  paragraphRaw: ReadonlyRefOrGetter<ILegalTextParagraph>
) {
  return {
    oldVersionId: computed(() => {
      const paragraph = toValue(paragraphRaw);
      return paragraph.valid_until ? paragraph.id : undefined;
    }),
  };
}
